// extracted by mini-css-extract-plugin
export default {"labelForms":"labelForms_labelForms__xCYkT"};